<template>
    <div>
        <v-container>
            <v-row>
                <v-col xs="12">
                    <h1>Forbidden</h1>
                </v-col>
            </v-row>
        </v-container>
    </div>


</template>

<script>
    export default {

    }
</script>

<style scoped>

</style>
